const current_version = 24;

const current_init_sql = [
    `DROP TABLE IF EXISTS t_version;`,
    `CREATE TABLE t_version(key PRIMARY KEY, val);`,
    `INSERT INTO t_version(key, val) VALUES('db_version', '6');`,
    
    `DROP TABLE IF EXISTS t_config;`,
    `CREATE TABLE t_config(key PRIMARY KEY, val, utime, ctime);`,
    
    `DROP TABLE IF EXISTS t_qh_auth;`,
    `CREATE TABLE t_qh_auth(qid PRIMARY KEY, uidA, uidB, time);`,
    
    `DROP TABLE IF EXISTS t_auth;`, 
    `CREATE TABLE t_auth(uid PRIMARY KEY, token, appkey, vcode, baseUrl, syncUrl, customerServiceUrl, secret, encrypt, loginType, account, phone, nick, avatar, utime, switch_regist, switch_tab_main, switch_tab_mine, switch_rtc);`,
    
    `DROP TABLE IF EXISTS t_msg;`,
    'CREATE TABLE t_msg(' +
    'uniqueId PRIMARY KEY, mid, tid, tmid, cid, sender,' +
    'stime, type, content, meta, etime,' +
    'target_cnt, target_uids, read_cnt, read_uids, at_cnt,' +
    'at_uids, atread_cnt, atread_uids, mask, visible,' +
    'audit_word, audit_word_tip, audit_rst, audit_mid, lbatchid, lutime,' +
    'lctime, latme, send_statue, upload_statue, upload_path, thumbnailPath)',

    `DROP TABLE IF EXISTS t_userobj;`,
    `CREATE TABLE t_userobj(res_id, res_type, data, attr, utime, lutime, lctime, primary key(res_id, res_type));`,
    
    `DROP TABLE IF EXISTS t_friend;`,
    `CREATE TABLE t_friend(uid PRIMARY KEY, lutime, lctime);`,
    
    `DROP TABLE IF EXISTS t_app;`,
    'CREATE TABLE t_app(' +
    'appkey PRIMARY KEY, main_appkey, plat, company, company_short,' +
    'company_desc, category, admin_uid, ruid, status,' +
    'ctime, lutime, lctime);',
    
    `DROP TABLE IF EXISTS t_task;`,
    'CREATE TABLE t_task(' +
    'taskid PRIMARY KEY, type, data, status, errmsg,' +
    'lutime, lctime);',
    
    `DROP TABLE IF EXISTS t_user;`,
    'CREATE TABLE t_user(' +
    'uid PRIMARY KEY, name, name_py, name_pys, nick, sex, birth,' +
    'nick_py, nick_pys, telno, privacy, email, employee,' +
    'position, present, titles, department, employee_id, appkey, main_appkey,' +
    'avatar, status, remark, remark_py, remark_pys,' +
    'rtel, rtelCheck, remail, remailCheck, qrcode, qrcode_desc,' +
    'lutime, lctime);',

    'DROP INDEX IF EXISTS idx_user_uid',
    'CREATE INDEX idx_user_uid ON t_user(uid);',
    
    'DROP TABLE IF EXISTS t_group;',
    'CREATE TABLE t_group(' +
    'tid PRIMARY KEY, uid, name, name_py, name_pys,' +
    'admin_uids, cid, notice, notice_read, tag, tagid,' +
    'ctime, lutime, lctime, avatar, scene,' +
    'sceneid, flag, qrcode, qrcode_desc, group_check_switch, group_allow_member_list,' +
    'group_allow_member_visit, group_friend_invite_enter, group_ban_chat, group_chat_interval_time, remark, group_sn, intro, group_member_alias, group_member_image, group_member_video,group_member_doc, group_member_quit_msg, join_notice, group_admin_special, member_count, member_synced);',
    
    `DROP TABLE IF EXISTS t_topic;`,
    'CREATE TABLE t_topic(' +
    'tid PRIMARY KEY, uid, name, cid, ctime,' +
    'type, sid, hidemid, ord, lv_time,' +
    'ls_mid, remark, mute, draft, lutime, lctime, unread, msg_synced,' +
    'bridge_state, bridge_cursor, bridge_pages, bridge_epoch, bridge_updated_at);',
    
    'DROP INDEX IF EXISTS idx_topic_tid',
    'CREATE INDEX idx_topic_tid ON t_topic(tid);',
    
    `DROP TABLE IF EXISTS t_group_member;`,
    'CREATE TABLE t_group_member(primaryId PRIMARY KEY, tid, uid, name, name_py, name_pys, nick, nick_py, nick_pys, sex, birth, privacy, telno, email, appkey, main_appkey, avatar, remark, status, lutime, lctime);',
    
    'DROP INDEX IF EXISTS idx_group_member_tid_uid',
    'CREATE INDEX idx_group_member_tid_uid ON t_group_member(tid, uid);',
    
    'DROP INDEX IF EXISTS idx_msg_tid',
    'CREATE INDEX idx_msg_tid ON t_msg(tid);',
    'DROP INDEX IF EXISTS idx_msg_tid_stime',
    'CREATE INDEX idx_msg_tid_stime ON t_msg(tid, stime DESC);',
    
    'DROP TABLE IF EXISTS t_user_ref;',
    'CREATE TABLE t_user_ref(uid PRIMARY KEY, isfriend, isstaff, ischain, plat, appkey, main_appkey, lutime, lctime);',
    
    'DROP TABLE IF EXISTS t_friend_black;',
    'CREATE TABLE t_friend_black(uid PRIMARY KEY, black, lutime, lctime);',

    'DROP TABLE IF EXISTS t_user_devices;',
    'CREATE TABLE t_user_devices(uid PRIMARY KEY, devices, lutime, lctime);',

    'DROP TABLE IF EXISTS t_group_summary;',
    'CREATE TABLE t_group_summary(tid PRIMARY KEY, uid, name, name_py, name_pys, tag, tagid, avatar, remark, ctime, lutime, lctime);',
    
    'DROP TABLE IF EXISTS t_emoticon;',
    'CREATE TABLE t_emoticon(id PRIMARY KEY, url, ctime);',

    'DROP TABLE IF EXISTS t_label;',
    'CREATE TABLE t_label(label, uid, name, namePY, namePYS, nick, nickPY, nickPYS, email, appkey, mainAppkey, avatar, remark, remarkPY, remarkPYS, ctime, UNIQUE(label, uid));',
    
    'DROP TABLE IF EXISTS t_translate;',
    'CREATE TABLE t_translate(mid PRIMARY KEY, src, desc);',
    
    `UPDATE t_version SET val=${current_version} WHERE key='db_version'`,
];



const current_clear_sql = ['drop table if exists t_version;'];

export { current_version, current_init_sql, current_clear_sql };
